import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import StatusLayout from "../components/Status/Layout/Layout";
import WelcomeBack from "../components/Registration/WelcomeBack/WelcomeBack";
import MailVerified from "../components/Registration/MailVerified/MailVerified";
import NRI from "../components/Registration/NRI/NRI";
import OTP from "../components/Registration/OTP/OTP";
import AccExists from "../components/Registration/AccExists/AccExists";
import PANInfo from "../components/Registration/PANInfo/PANInfo";
import Error from "../components/UI/ErrorScreen/ErrorScreen";
import ShareAdd from "../components/Registration/ShareAdd/ShareAdd";
import CheckStatusHome from "../components/Status/CheckStatus/CheckStatusHome";
import AccountNotFound from "../components/Status/AccountNotFound/AccountNotFound";
import StatusVerified from "../components/Status/StatusVerified/StatusVerified";
import DocsVerificationInProgress from "../components/Status/DocsVerificationInProgress/DocsVerificationInProgress";
import DocumentReject from "../components/Status/DocumentReject/DocumentReject";
import { statusUrl } from "../components/utils/constants";
import StatusContinue from "../components/Status/StatusContinue/StatusContinue";
import InstanHelp from "../components/InstantHelp/InstantHelp";
import ElogVerificationInProgress from "../components/Status/ElogVerificationInProgress/ElogVerificationInProgress";

const StatusRoutes = () => {
  return (
    <>
      <Routes>
        <Route
          path={statusUrl.statusHome}
          element={
            <InstanHelp panPageFlag={false}>
              <StatusLayout>
                <CheckStatusHome />
              </StatusLayout>
            </InstanHelp>
          }
        />
        <Route
          path={statusUrl.statusVerified}
          element={
            <InstanHelp panPageFlag={false}>
              <StatusLayout>
                <StatusVerified />
              </StatusLayout>
            </InstanHelp>
          }
        />
        <Route
          path={statusUrl.documentReject}
          element={
            <InstanHelp panPageFlag={false}>
              <StatusLayout>
                <DocumentReject />
              </StatusLayout>
            </InstanHelp>
          }
        />
        <Route
          path={statusUrl.docVerificationInProgress}
          element={
            <InstanHelp panPageFlag={false}>
              <StatusLayout>
                <DocsVerificationInProgress />
              </StatusLayout>
            </InstanHelp>
          }
        />
        <Route
          path={statusUrl.elogVerificationInProgress}
          element={
            <StatusLayout
              statusClassName={"statusLayoutNew"}
              edelLogoClass={"headerLogoLeftAlign"}
            >
              <ElogVerificationInProgress />
            </StatusLayout>
          }
        />
        <Route
          path={statusUrl.accountNotFound}
          element={
            <InstanHelp panPageFlag={false}>
              <StatusLayout>
                <AccountNotFound />
              </StatusLayout>
            </InstanHelp>
          }
        />
        <Route
          path={statusUrl.statusContinue}
          element={
            <InstanHelp panPageFlag={false}>
              <StatusLayout>
                <StatusContinue />
              </StatusLayout>
            </InstanHelp>
          }
        />
      </Routes>
    </>
  );
};

export default StatusRoutes;
